import { render, staticRenderFns } from "./AllowanceSummaryChart.vue?vue&type=template&id=3c13f317"
import script from "./AllowanceSummaryChart.vue?vue&type=script&lang=js"
export * from "./AllowanceSummaryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports